import { Link } from 'react-router-dom';
import { HealthcareEntityRep } from '../../../api';
import { Avatar } from '../Avatar';

export const HealthcareEntityRepRepresentation = ({
  healthcareEntityRep,
  showHealthcareOrganization = false,
}: {
  healthcareEntityRep: HealthcareEntityRep;
  showHealthcareOrganization?: boolean;
}) => (
  <div className="d-flex align-items-center gap-2">
    <Avatar size={50} />
    <div>
      {showHealthcareOrganization ? (
        <>
          <strong className="d-block">
            <Link to={`/app/healthcare-entity/${healthcareEntityRep.healthcare_entity.id}`}>
              {healthcareEntityRep.healthcare_entity.name}
            </Link>
          </strong>
          <div>
            {healthcareEntityRep.user.first_name} {healthcareEntityRep.user.last_name}
          </div>
        </>
      ) : (
        <strong className="d-block">
          {healthcareEntityRep.user.first_name} {healthcareEntityRep.user.last_name}
        </strong>
      )}
      <small>{healthcareEntityRep.title}</small>
    </div>
  </div>
);
